import { Button } from '@ds';
import { OrganTypeBadge } from '@ui';
import { CaseDuplicateType, OrganType } from '@/api/apis/case';

export type CasesDuplicatesProps = {
  duplicate: CaseDuplicateType;
  onClick: () => void;
};

export const CaseDuplicateItem = ({ duplicate, onClick }: CasesDuplicatesProps) => {
  const { caseId, caseNumber, caseName, organType } = duplicate;

  return (
    <Button
      size="md"
      variant="light"
      key={caseId}
      onClick={onClick}
      className="w-full flex items-center justify-start gap-2 rounded-md"
    >
      <OrganTypeBadge size="md" organ={organType as OrganType} />
      <div className="text-left">
        <p className="text-s-r text-black mb-0.5">{caseName}</p>
        <p className="text-xs-r text-base-20">{caseNumber}</p>
      </div>
    </Button>
  );
};
